import { FieldConfig } from "~/components/Forms/DealerPassportForm2/types";

export const getDealerGuideDirector = (
  t: (key: string) => string,
  prefix: string
): FieldConfig[] => [
  {
    name: `${prefix}name`,
    label: t(`dealers.nameDirector`),
    type: "text",
  },
  {
    name: `${prefix}nameGenitive`,
    label: t(`dealers.nameGenitiveDirector`),
    type: "text",
  },
  {
    name: `${prefix}position`,
    label: t(`dealers.positionDirector`),
    type: "text",
  },
  {
    name: `${prefix}positionGenitive`,
    label: t(`dealers.positionGenitiveDirector`),
    type: "text",
  },
  {
    name: `${prefix}code`,
    label: t(`dealers.codeDirector`),
    type: "text",
  },
  {
    name: `${prefix}fax`,
    label: t(`dealers.faxDirector`),
    type: "text",
  },
  {
    name: `${prefix}phone`,
    label: t(`dealers.phoneDirector`),
    type: "text",
  },
  {
    name: `${prefix}mphone`,
    label: t(`dealers.mphoneDirector`),
    type: "text",
    required: true,
  },
  {
    name: `${prefix}email`,
    label: t(`dealers.emailDirector`),
    type: "text",
  },
  {
    name: `${prefix}positionImported`,
    label: t(`dealers.positionImportedDirector`),
    type: "hidden",
  },
  {
    name: `${prefix}termOfAuthority`,
    label: t(`dealers.termOfAuthorityDirector`),
    type: "hidden",
  },
];

export const getDealerGuide = (
  t: (key: string) => string,
  prefix: string
): FieldConfig[] => [
  {
    name: `${prefix}name`,
    label: t(`dealers.${prefix}Name`),
    type: "text",
  },
  {
    name: `${prefix}code`,
    label: t(`dealers.${prefix}Code`),
    type: "text",
    required: true,
  },
  {
    name: `${prefix}phone`,
    label: t(`dealers.phone`),
    type: "text",
  },
  {
    name: `${prefix}fax`,
    label: t(`dealers.fax`),
    type: "text",
  },
  {
    name: `${prefix}email`,
    label: t(`dealers.email`),
    type: "text",
    disabled: true,
  },
];
